import styled from '@emotion/styled';
import { Flex, Text } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import { brandColors } from '@/lib/theme/colors';
import PriceContainer from '../PriceContainer';

export type UnavailableProps = {
  reason: string;
};

const StyledText = styled(Text)`
  font-family: ${themeGet('headerFontFamily')};
`;

const Unavailable = ({ reason }: UnavailableProps) => {
  return (
    <PriceContainer>
      <Flex alignItems="flex-end" flexDirection="column">
        <StyledText
          mb="1"
          textAlign="right"
          fontSize={['sm', null, 'md']}
          fontWeight="bold"
          color={brandColors.darkTertiary}
        >
          Unavailable
        </StyledText>
        <Text
          textAlign="right"
          lineHeight={['1.25rem', null, '1.5rem']}
          fontSize={['xs', null, 'sm']}
          color={brandColors.charcoal}
        >
          {reason}
        </Text>
      </Flex>
    </PriceContainer>
  );
};

export default Unavailable;
